import {TopHeaderSection} from "./topHeaderSection";
import './style.css';

export const HeaderSection = () => {
    return <TopHeaderSection/>
}
